import validation from "vee-validate/dist/locale/fr.json";

export const vee_validate = {
    fields: {

        gender:'genre',
        firstname:'prénom',
        lastname:'nom',

        email:'e-mail',
        optin_terms_conditions:'conditions générales',
        optin_privacy:'politique de confidentalité',

        street:'rue',
        street_number:'numéro',
        street_box_number:'boîte',
        zip_code:'code postal',
        city:'ville',

        phone:'numéro de téléphone',

        iban:'IBAN',

        sms:'code de vérification',

        password:'mot de passe',
        password_confirmation:'confirmation de mot de passe',
    },
    validation: {
        ...validation.messages,
        is: '{_field_} n\'est pas valide',
        name:'{_field_} n\'est pas valide',

    },
    custom: {
        optin_terms_conditions: {
            required: "Vous devez accepter les conditions générales pour pouvoir continuer",
        },
        optin_privacy: {
            required: "Vous devez accepter la politique de confidentalité pour pouvoir continuer",
        },
        optin_iban: {
            required: "Ce champ est obligatoire",
        },
    }
}
